// extracted by mini-css-extract-plugin
module.exports = {"root":"K_b4","full-width":"K_cK","fullWidth":"K_cK"};